import React from 'react';

const SectionTransition = ({ sectionTitle, onReview, onNext, isLastSection }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-6 animate-fadeIn bg-gradient-to-b from-amber-50 to-orange-50 dark:from-slate-900 dark:to-slate-800">
      <div className="bg-white dark:bg-card-dark rounded-3xl shadow-2xl border-4 border-amber-200 dark:border-amber-700 max-w-lg w-full overflow-hidden relative">

        {/* Decorative top gradient band */}
        <div className="h-3 w-full bg-gradient-to-r from-amber-400 via-orange-400 to-pink-400" />

        <div className="relative p-8 flex flex-col items-center text-center z-10">

          {/* Trophy Badge */}
          <div className="w-24 h-24 rounded-3xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-5xl shadow-xl shadow-amber-300 mb-6 border-4 border-white transform -rotate-3">
            🏆
          </div>

          <h2 className="font-black text-3xl mb-2 bg-gradient-to-r from-amber-500 to-orange-600 bg-clip-text text-transparent">
            Hoàn thành phần thi!
          </h2>
          <p className="text-slate-500 dark:text-slate-400 text-lg font-semibold mb-6">
            Bạn đã xong phần{' '}
            <span className="font-black text-amber-600 dark:text-amber-400">{sectionTitle}</span>
            . Thật tuyệt vời! ⭐
          </p>

          {/* Warning Box */}
          <div className="bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-300 dark:border-amber-700 rounded-2xl p-4 mb-8 w-full flex gap-3 text-left">
            <span className="text-2xl flex-shrink-0">⚠️</span>
            <div>
              <h4 className="font-black text-amber-800 dark:text-amber-200 text-sm uppercase tracking-wide mb-1">
                Lưu ý quan trọng
              </h4>
              <p className="text-sm text-amber-700 dark:text-amber-300 leading-snug font-medium">
                Sau khi chuyển sang phần tiếp theo, bạn{' '}
                <strong>không thể</strong> quay lại thay đổi câu trả lời.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button
              onClick={onReview}
              className="flex-1 py-3.5 px-6 bg-white border-2 border-slate-200 text-slate-700 hover:bg-amber-50 hover:border-amber-300 hover:text-amber-700 font-black rounded-2xl transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-2 dark:bg-transparent dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
            >
              <span className="material-symbols-outlined">history</span>
              <span>Xem lại câu trả lời</span>
            </button>

            <button
              onClick={onNext}
              className="flex-1 py-3.5 px-6 text-white font-black rounded-2xl shadow-lg shadow-amber-200 hover:shadow-xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center gap-2 bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 border-2 border-amber-300"
            >
              <span>{isLastSection ? '🎉 Nộp bài' : 'Phần tiếp theo'}</span>
              <span className="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTransition;
